import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1be79f83-3969-45b0-8e96-f7609932169e/artifacts/rxkk1yi8_0E7539D4-89C8-4BC5-A95C-974033632CC9.png";

export function WakzyLogo({ className = "h-12 w-auto", to, asLink = true }) {
  const img = <img src={LOGO_URL} alt="Wakzy Auto Sales & Services LLC" className={className} />;
  if (!asLink || !to) {
    return <span className="inline-flex items-center" data-testid="wakzy-logo">{img}</span>;
  }
  return (
    <Link to={to} className="inline-flex items-center" data-testid="wakzy-logo-link">
      {img}
    </Link>
  );
}

export function WakzyMark({ size = 28 }) {
  return (
    <img
      src={LOGO_URL}
      alt="Wakzy"
      style={{ height: size, width: "auto" }}
      className="inline-block"
    />
  );
}
